import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-tight transition-all duration-300 will-change-transform hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900";

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
};

const variants = {
  primary:
    "bg-sky-400 text-ink-900 hover:bg-sky-300 shadow-[0_8px_30px_rgba(56,189,248,0.25)] hover:shadow-[0_14px_44px_rgba(56,189,248,0.5)]",
  outline:
    "border border-white/15 bg-white/5 text-white hover:border-sky-400/60 hover:bg-white/10 hover:shadow-[0_10px_36px_rgba(56,189,248,0.18)] backdrop-blur-md",
  ghost: "text-slate-200 hover:text-white",
};

export default function PillButton({
  children,
  to,
  href,
  onClick,
  variant = "primary",
  size = "md",
  arrow = true,
  className = "",
  testId,
}) {
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {arrow && (
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </>
  );

  const motionProps = { whileTap: { scale: 0.97 } };

  if (to) {
    return (
      <motion.div {...motionProps} className="inline-flex">
        <Link to={to} className={cls} data-testid={testId}>
          {inner}
        </Link>
      </motion.div>
    );
  }
  if (href) {
    return (
      <motion.a {...motionProps} href={href} className={cls} data-testid={testId}>
        {inner}
      </motion.a>
    );
  }
  return (
    <motion.button {...motionProps} onClick={onClick} className={cls} data-testid={testId} type="button">
      {inner}
    </motion.button>
  );
}
